import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-leave-page-confirmation',
    templateUrl: './leave-page-confirmation.component.html',
    styleUrls: ['./leave-page-confirmation.component.scss'],
    standalone: false
})
export class LeavePageConfirmationComponent implements OnDestroy {
    @ViewChild('overlay') overlay;
    public onOptionSelected: Subject<boolean>;

    style = {
        display: 'none',
    };

    constructor() {
        this.onOptionSelected = new Subject();
    }

    ngOnDestroy(): void {
        this.onOptionSelected.complete();
    }

    public setVisible(visible: boolean) {
        this.style.display = visible ? 'block' : 'none';
    }

    emitValue(value: boolean) {
        this.onOptionSelected.next(value);
        this.setVisible(false);
    }
}
